/**
 * Työntekijän self-service-portaalin client.
 *
 * Käyttää eri tokenia kuin admin-puoli – tallennetaan localStorageen erikseen
 * jotta voi käyttää molempia rinnakkain ilman ristikkäisvaikutusta.
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "emp_portal_token";
const USER_KEY = "emp_portal_user";

export const portalApi = axios.create({ baseURL: API, withCredentials: true });

portalApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function setPortalSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function getPortalUser() {
  try { return JSON.parse(localStorage.getItem(USER_KEY)) || null; }
  catch { return null; }
}

export function getPortalToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function clearPortalSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function formatPortalError(err) {
  return err?.response?.data?.detail || err?.message || "Tapahtui virhe";
}
